<template>
  <footer class="footer">
      <div class="container">
          <div class="row">
              <div class="col-sm-3">
            <a href="https://nomundo.pt/" target="_blank"><img src="../assets/logo-nomundo.png"/></a>
              </div>
              <div class="col-sm-9">
                <p class="email_footer">                    
                    | <a href="./documents/informacao-geral-sobre-protecao-de-dados-pessoais-aos-socios-do-camtil.pdf" target="_blank">TERMOS E CONDIÇÕES</a>
                    <i class="fa fa-envelope" style="margin-left:10px;"></i> E-mail: <a href="mailto:secretaria@camtil.pt">secretaria@camtil.pt</a></p>
              </div>
          </div>
        </div>
  </footer>
</template>

<script>
export default {
    name: 'FooterFront'
}
</script>

<style>
    footer {
        background: #52751D;
        height: 80px;
    }

    footer img{
        position: absolute;
        height: 50px;
        /* top: 20px; */
    }

    .footer {
        flex-shrink: 0;
        padding: 20px;
        margin-top: 50px;
    }

    .email_footer{
        text-align: right;
        padding: 10px;
        color: white;
    }

    .email_footer a{
        color: white;
    }

    .email_footer a:hover {
        color: white;
        text-decoration: none;
    }
    
</style>